import Slider from "/Assets/libs/slider.js";
import { onReady } from "/Assets/js/utilities.js";

export default class CustomerStorySlider {
    init() {
        onReady(() => {
            var clsPrefix, selector, stopTime, duration;

            selector = ".slider";
            clsPrefix = "slider";
            stopTime = 5000;
            duration = 500;

            var initializeSlider = document.querySelector(".slider");

            if (!initializeSlider)
                return;

            var autoSlider = initializeSlider.dataset.auto;
            var autoBool = (autoSlider === "true");

            const slider = new Slider({
                selector: selector,
                clsPrefix: clsPrefix,
                duration: duration,
                loop: true,
                autoHeight: true,
                onChange: function () {
                    this.updatePagination(clsPrefix + "__pagination-btn", clsPrefix + "__item");
                }
            });

            slider.setPagination(clsPrefix + "__pagination", clsPrefix + "__pagination-btn", clsPrefix + "__item");

            if (autoBool) {
                slider.setHoverPause(stopTime);
            }
        });
    }
}
